document.addEventListener('DOMContentLoaded', function() {
    var verticalSectionsToShow = 2; // Número de seções "vertical" a serem exibidas
    var collageSectionsToShow = 1;  // Número de seções "collage" a serem exibidas

    // Seleciona todas as seções com data-section-type igual a "featured-collection"
    var allSections = document.querySelectorAll('section[data-section-type="featured-collection"]');
    
    var verticalSections = []; // Para armazenar seções com layout "vertical"
    var collageSections = [];  // Para armazenar seções com layout "collage"

    // Processa todas as seções
    allSections.forEach(function(section) {
        // Pega o valor do atributo data-section-settings
        var settings = section.getAttribute('data-section-settings');

        try {
            // Substitui &quot; por " e parseia o JSON
            var parsedSettings = JSON.parse(settings.replace(/&quot;/g, '"'));

            // Verifica o layout e separa as seções
            if (parsedSettings.layout === "vertical") {
                // Esconde seções com layout "vertical" inicialmente
                section.style.display = 'none';
                verticalSections.push(section);
            } else if (parsedSettings.layout === "collage") {
                // Esconde seções com layout "collage" inicialmente
                section.style.display = 'none';
                collageSections.push(section);
            }
        } catch (e) {
            console.error('Erro ao parsear data-section-settings:', e);
        }
    });

    // Função para mostrar seções aleatoriamente
    function showRandomSections(sections, sectionsToShow) {
        var totalSections = sections.length;
        if (totalSections < sectionsToShow) {
            sectionsToShow = totalSections;
        }

        var selectedSections = [];
        while (selectedSections.length < sectionsToShow) {
            var randomIndex = Math.floor(Math.random() * totalSections);
            if (!selectedSections.includes(sections[randomIndex])) {
                selectedSections.push(sections[randomIndex]);
            }
        }

        // Mostra as seções selecionadas
        selectedSections.forEach(function(section) {
            section.style.display = 'block';
        });

        return selectedSections;
    }

    // Mostra as seções "vertical" e "collage" aleatoriamente
    var shownVerticalSections = showRandomSections(verticalSections, verticalSectionsToShow);
    var shownCollageSections = showRandomSections(collageSections, collageSectionsToShow);    
});
